const task = {
  namespaced: true,

  state: {
    task: {},
  },

  mutations: {
    SET_EDITTING_TASK(state, task) {
      state.task = task
    }
  },

  getters: {
    GET_TASK: state => state.task
  }
}

export default {
  ...task,
};